import script from "./FullCalendarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullCalendarComponent.vue?vue&type=script&setup=true&lang=ts"

import "./FullCalendarComponent.vue?vue&type=style&index=0&id=5f2799ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f2799ae"]])

export default __exports__